let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6VRn8")).then(() => parcelRequire('bJj5X'));